import { defineComponent as _defineComponent } from 'vue'
import { ActionProps } from "@/components/atoms/action/Action.vue";
import MiniCard from "@/components/molecules/card/MiniCard.vue";
import { formatNumberToMoneyString } from "@/utils/formatters";
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import Loading from "@/components/atoms/loading/Loading.vue";

interface FacilityCardProps {
  id?: string;
  name?: string;
  range?: string;
  country?: string;
  isSelected?: boolean;
  isUnique?: boolean;
  onSelect: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FacilityCard',
  props: {
    id: null,
    name: null,
    range: null,
    country: null,
    isSelected: { type: Boolean },
    isUnique: { type: Boolean },
    onSelect: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  name?: string;
  range?: string;
  country?: string;
  isSelected?: boolean;
  isUnique?: boolean;
  onSelect: () => void;
};



const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;
const branches = ref<any>({});
const isLoading = ref<boolean>(false);

async function loadCompanyBranches() {
  isLoading.value = true;
  try {
    const response: any = await proxy.$root._post(`companies/one/${props.id}`, {models: "branches"}) || { data : [] };
    branches.value = response.data[0] && response.data[0].branches[0];
  } catch (e) {
    console.error('Error loading branches:', e);
    branches.value = [];
  } finally {
    isLoading.value = false;
  }
}

const icon = `
<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 4h12M6 4v16M6 4H5m13 0v16m0-16h1m-1 16H6m12 0h1M6 20H5M9 7h1v1H9V7Zm5 0h1v1h-1V7Zm-5 4h1v1H9v-1Zm5 0h1v1h-1v-1Zm-3 4h2a1 1 0 0 1 1 1v4h-4v-4a1 1 0 0 1 1-1Z"/>
</svg>
`;

const badge = computed(() => ({
  label: props.range,
  variant: props.isSelected ? "danger" : "neutral"
}));

const actions = computed(() => [
  props.isSelected ? { label: "Seleccionado", variant: "disabled" } : { label: "Seleccionar", variant: "danger", onClick: props.onSelect },
  props.isSelected && { label: "Cotizar", href: "/requests/quotes", variant: "muted" },
  props.isSelected && { label: "Nueva cotización", href: "/requests/new", variant: "muted" },
  props.isSelected && { label: "Bordereaux", href: "/requests/bordereaux", variant: "muted" },
].filter(Boolean) as ActionProps[]);

const metrics = computed(() => [
  { label: "Cobertura", value: branches.value.title },
  { label: "Capacidad", value: `$${formatNumberToMoneyString(branches.value.companies_branches._limit)}` },
]);

onMounted(async () => {
  await loadCompanyBranches();
});


return { __sfc: true,props, instance, proxy, branches, isLoading, loadCompanyBranches, icon, badge, actions, metrics, MiniCard, Loading }
}

})